import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@environment';
import { MainCountsModel } from '../../../core/models/main-counts-model.model';

@Injectable({
    providedIn: 'root',
})
export class FolderService {
    constructor(private httpClient: HttpClient) {}

    get(): Observable<MainCountsModel> {
        return this.httpClient.get<MainCountsModel>(environment.apiInboxUrl + 'folders/');
    }
}
